import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { classToPlain } from 'class-transformer';

import { Login } from '../models/login.model';
import { ResetPassword } from '../models/reset-password.model';
import { User } from '../models/user.model';
import { LocalStorageManager } from '../utils/local-storage';
import { BaseService } from './base.service';

export class AuthService extends BaseService {

	private TOKEN_COOKIE = process.env.VUE_APP_TOKEN_COOKIE as string;
	private USER_COOKIE = process.env.VUE_APP_USER_COOKIE as string;

	constructor(http: AxiosInstance) {
		super(http);
	}

	async login(login: Login): Promise<User> {
		const token = await this.getAnonymousToken();
		const httpOptions: AxiosRequestConfig = {
			headers: {
				'Authorization': `Bearer ${token.jwt}`
			}
		};
		const user = await this.mapResponse<User>(this.http.post('/ws/user/login', classToPlain(login), httpOptions), User);
		LocalStorageManager.set(this.TOKEN_COOKIE, user.token as string);
		LocalStorageManager.set(this.USER_COOKIE, user.id.toString());
		return user;
	}

	async resetPasswordRequest(request: any): Promise<any> {
		const token = await this.getAnonymousToken();
		const httpOptions: AxiosRequestConfig = {
			headers: {
				'Authorization': `Bearer ${token.jwt}`
			}
		};
		const res = await this.mapResponse<any>(this.http.post('/ws/access/resetpwd', request, httpOptions));

		return res;
	}

	async resetPasswordApply(request: ResetPassword): Promise<any> {
		const token = await this.getAnonymousToken();
		const httpOptions: AxiosRequestConfig = {
			headers: {
				'Authorization': `Bearer ${token.jwt}`
			}
		};
		const res = await this.mapResponse<any>(this.http.post('/ws/resetpassword/new', request, httpOptions));

		return res;
	}

	async renew(): Promise<any> {
		const httpOptions: AxiosRequestConfig = {
			headers: {
				'Authorization': `Bearer ${this.getToken()}`
			}
		};
		const token = await this.mapResponse<{ jwt: string }>(this.http.get('/ws/jwt/renew', httpOptions));
		LocalStorageManager.set(this.TOKEN_COOKIE, token.jwt as string);
	}

	async getAnonymousToken(): Promise<any> {
		return this.mapResponse(this.http.get('/ws/jwt/token', {}));
	}

	async getLoggedUser(): Promise<User> {
		const user = LocalStorageManager.get(this.USER_COOKIE);
		const id = +(user as string);
		const result = await this.getUser(id);
		return result;
	}

	async logout(): Promise<any> {
		await this.mapResponse<any>(this.http.post('/ws/user/logout', {}));
		this.deleteCookies();
	}

	getToken() {
		return LocalStorageManager.get(this.TOKEN_COOKIE);
	}

	private getUser(id: number): Promise<User> {
		return this.mapResponse(this.http.get(`/ws/user/${id}`), User);
	}

	public deleteCookies() {
		LocalStorageManager.remove(this.TOKEN_COOKIE);
		LocalStorageManager.remove(this.USER_COOKIE);
	}

}